(function(root, factory){
    if(typeof module === 'object' && module.exports) {
        module.exports = factory();
    }else{
        root.store = factory();
    }
})(this, function() {
    function isLocalUseable() {
        try {
            var storage = window.localStorage;
            var x = '__storage_test__';
            storage.setItem(x, 1);
            storage.removeItem(x);

            return true;
        }
        catch (e) {
            return false;
        }
    }

    var store = {
        set: function (name, value, expire) {
            if (isLocalUseable()) {
                this.local.set(name, value);
            } else {
                this.cookie.set(name, value, expire);
            }
        },
        get: function (name) {
            if (isLocalUseable()) {
                return this.local.get(name);
            }

            return this.cookie.get(name);
        },

        cookie: {
            set: function (name, value, expire) {
                var d = new Date();
                if (expire) {
                    d.setTime(d.getTime() + expire);
                } else {
                    d.setTime(d.getTime() + (100 * 365 * 24 * 60 * 60 * 1000));
                }

                var expires = 'expires=' + d.toUTCString();

                value = encodeURI(value);
                document.cookie = name + '=' + value + '; ' + expires +';domain=.huya.com;path=/';
            },
            get: function (name) {
	            var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
	            if(arr=document.cookie.match(reg))
		            return decodeURI(arr[2]);
	            else
		            return '';
            },
            del: function (name) { // 删除
                var exp = new Date();
                exp.setTime(exp.getTime() - 1);
                var cval = this.get(name);
                if (cval) {
                    this.set(name, '', exp);
                    //document.cookie = name + '=' + cval + ';domain=.yaoguo.com;expires=' + exp.toGMTString();
                }
            }
        },
        local: {
            set: function (name, value) {
                localStorage.setItem(name, value);
            },
            get: function (name) {
                return localStorage.getItem(name);
            },
            del: function (name) {
                localStorage.removeItem(name);
            }
        }
    };

    return store;
});





// WEBPACK FOOTER //
// ./src/common/js/store.js